import React, { useState } from "react";
import api from "../lib/api";
import Layout from "../components/Layout";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import FinanceReportPanel from "./FinanceReportPanel";

const FinanceReport = () => {
  const [locked, setLocked] = useState(true);
  const [lockPwd, setLockPwd] = useState("");
  const [unlocking, setUnlocking] = useState(false);

  const submitUnlock = async (e) => {
    e.preventDefault();
    setUnlocking(true);
    try {
      await api.post("/settings/unlock", { password: lockPwd });
      setLocked(false);
      setLockPwd("");
      toast.success("Akses laporan keuangan terbuka");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Password salah");
    } finally {
      setUnlocking(false);
    }
  };

  if (locked) {
    return (
      <Layout>
        <div className="max-w-md mx-auto mt-12 bg-white border border-[#E4E4E7]" data-testid="finance-lock-screen">
          <div className="px-6 py-4 border-b border-[#E4E4E7]">
            <div className="label-cap">Akses Terproteksi</div>
            <h2 className="font-heading text-2xl font-bold">Laporan Keuangan</h2>
          </div>
          <form onSubmit={submitUnlock} className="p-6 space-y-4">
            <p className="text-sm text-[#52525B]">Halaman ini diproteksi. Masukkan password pengaturan untuk melihat laporan keuangan.</p>
            <input type="password" required autoFocus value={lockPwd} onChange={(e) => setLockPwd(e.target.value)} placeholder="Password pengaturan" data-testid="finance-unlock-input" className="w-full px-3 py-2.5 border border-[#E4E4E7] text-sm outline-none focus:border-[#002FA7] font-mono" />
            <button type="submit" disabled={unlocking} data-testid="finance-unlock-button" className="w-full bg-[#002FA7] hover:bg-[#00227A] text-white text-xs font-bold uppercase tracking-wider px-6 py-3 flex items-center justify-center gap-2 disabled:opacity-60">
              <Lock size={14} /> {unlocking ? "Memverifikasi…" : "Buka Laporan Keuangan"}
            </button>
          </form>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="mb-6">
        <div className="label-cap mb-2">Analitik Keuangan</div>
        <h1 className="font-heading text-4xl font-black tracking-tight">Laporan Keuangan</h1>
      </div>
      <div className="max-w-5xl">
        <FinanceReportPanel />
      </div>
    </Layout>
  );
};

export default FinanceReport;
